import gql from 'graphql-tag'

export const subscriptionKeys = gql`
  query subscriptionKeys($companyId: ID) {
    subscriptionKeys(companyId: $companyId) {
      id
      prices {
        price
        currency
        wholesalePrice
      }
      subscriptionLength
      activeFrom
      companyName
      initialFocDays
      prepaidPeriodDays
      autoStartPrepaidPeriod
    }
  }
`
